import React from 'react';
import { Input, inputStyleClasses } from 'Components/Input';
import DatePicker from 'Components/DatePicker';
import Select from 'Components/Select';
import moment from 'moment';

export default function GeneralInformation({
  description,
  inspectionDate,
  year,
  yearList,
  errors,
  handleInputChange,
  handleSelect,
  handleYearSelect,
  address,
  manufacturerAddresses,
}) {
  return (
    <section className='scene_section'>
      <header>General Info</header>
      <Input
        mainWrapperClassName='_width_pc_100'
        styleClass={inputStyleClasses.primary}
        label='Description *'
        maxLength={250}
        alwaysTextField
        error={errors.description}
        value={description}
        onChange={handleInputChange('description')}
      />
      <DatePicker
        label='Inspection Date *'
        error={
          (moment().utc().hour(23).minute(59).second(59).isBefore(inspectionDate) &&
            'Cannot select Inspection Date in the future') ||
          errors.inspectionDate
        }
        selectedDate={inspectionDate}
        mainWrapperClassName='input__main-wrapper_primary _margin_right_30 _margin_top_18'
        handleSelectDate={handleSelect('inspectionDate')}
      />
      <Select
        selectionList={yearList}
        defaultItem={year}
        mainWrapperClassName='input__main-wrapper_primary'
        type='primary'
        label='Model Year *'
        error={errors.year}
        handleSelect={handleYearSelect}
      />
      <Select
        selectionList={manufacturerAddresses}
        defaultItem={address}
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        type='primary'
        label='Select Address *'
        itemNameIndicator='name'
        error={errors.address}
        handleSelect={handleSelect('address')}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/New/GeneralInformation.jsx